import { render, staticRenderFns } from "./game-3.vue?vue&type=template&id=87c0bec4&scoped=true&"
import script from "./game-3.vue?vue&type=script&lang=js&"
export * from "./game-3.vue?vue&type=script&lang=js&"
import style0 from "./game-3.vue?vue&type=style&index=0&id=87c0bec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c0bec4",
  null
  
)

export default component.exports